import { ref } from "vue";

// モジュールスコープで保持することで、import 先すべてで共有される
const isKonamiIdLoginClickable = ref(true);

export const useKonamiIdLoginState = () => {
    const lock = () => {
        isKonamiIdLoginClickable.value = false;
    };

    const unlock = () => {
        isKonamiIdLoginClickable.value = true;
    };

    const setClickable = (isClickable) => {
        isKonamiIdLoginClickable.value = Boolean(isClickable);
    };

    return {
        isKonamiIdLoginClickable,
        lock,
        unlock,
        setClickable,
    };
};
